import { throwError } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'
import { env } from 'shared/env'

const baseURL = env.SERVER_ADDR

const requestHeader = () => {
  const headers = {
    'Content-Type': 'application/json',
  }
  const userData = JSON.parse(localStorage.getItem('user_info') || '{}')
  let token: string | boolean = false
  if (userData.token) {
    token = userData.token
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}

const handleError = (operation: string) => (err: any) => {
  const errMsg = `Error in ${operation}()`

  if (err.status === 401) {
    localStorage.clear()
    window.location.href = '/auth/login'
  }
  return throwError(() => console.error(errMsg))
}

export const getOptionsSettings = (payload?) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options`,
    body: payload,
  }).pipe(catchError(handleError('login')))

export const getCurrencyList = (payload?) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options/currencies`,
    body: payload,
  }).pipe(catchError(handleError('login')))

export const getTimezones = (payload?) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options/timezones`,
    body: payload,
  }).pipe(catchError(handleError('login')))

export const getCountryStates = (country) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options/countries/${country}/states`,
  }).pipe(catchError(handleError('getCountryStates')))

export const validateStoreOnboarding = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/stores/wc/validate`,
    body: payload,
  }).pipe(catchError(handleError('login')))

export const verifyConnection = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/stores/verify/${
      payload.sar_id || payload.store_id
    }`,
    body: payload,
  }).pipe(catchError(handleError('login')))

export const validateShopifyStoreOnboarding = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/stores/shopify/validate`,
    body: payload,
  }).pipe(catchError(handleError('login')))

export const registerCustomerStore = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/stores/${payload.store_type}`,
    body: payload,
  }).pipe(catchError(handleError('login')))
